/**
 * 動態網址的 `:href` 守門（批185，審查 FE-01）。
 *
 * 〈兌換紀錄〉原本把部署端自報的 `public_url` 原樣綁進 `<a :href>`——後端不驗協定的那段期間，
 * `javascript:…` 會落庫；Vue 不會替 href 擋協定，點下去就在後台的來源執行（讀得到 localStorage
 * 裡的 token）。後端已改成只收 http(s)（`api/public._clean_public_url`＋`0047` 清洗），這裡是另一半：
 * **凡是 `:href`／`window.open` 的動態網址，一律先過這支**。
 *
 * 只放行：絕對網址、協定是 http／https、有主機名、沒有帳密段、沒有空白或控制字元。其他一律 `null`
 * （呼叫端改成純文字顯示）。回傳原字串（不正規化），畫面上看到的就是實際連過去的。
 *
 * ★ portal 有一份同名同內容的 `portal/src/lib/safeUrl.ts`。
 */
export function safeHttpUrl(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const text = value.trim()
  if (!text) return null
  for (const ch of text) {
    const code = ch.charCodeAt(0)
    if (code <= 0x20 || code === 0x7f) return null
  }
  let url: URL
  try {
    url = new URL(text)
  } catch {
    return null
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return null
  if (!url.hostname || url.username || url.password) return null
  return text
}
